import React, { useEffect, useState } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Card, CardBody, Container, FormGroup, Input, Label, Badge, Button, CardHeader, Row, Col } from 'reactstrap';
import { IoIosClose } from "react-icons/io";
import _ from 'lodash';

import LoadingOverlay from 'components/Indicator/LoadingOverlay';
import AlertNotSubscribe from 'components/Alert'
import PageTitle from 'components/Title/PageTitle';
import Lang from 'Lang/General';
import MediaDatabase from 'SharedModules/MediaDatabase'
import WithHOC from './action';
import { SketchPicker } from 'react-color';
import { defaultFormVal } from './assets'

function Setting(props) {
  const [formData, setFormData] = useState(defaultFormVal)
  const [selectedImage, updateSelectedImage] = useState('')
  const onHandleSubmit = () => {
    if (!props.selectedSetting.id) {
      props.createSetting({
        ...formData
      })
      return
    }

    props.updateSetting({
      ...formData
    })
  }

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Customer Dialogue System' })

    props.onChangeSettingHOC('subscribedPackage', tmpIndex > -1)
    tmpIndex > -1 && props.getSelectedSetting()
  }, [])

  useEffect(() => {
    if (props.selectedSetting) {
      setFormData(props.selectedSetting)
    }
  }, [props.selectedSetting])

  return (
    <>
      <PageTitle
        heading={Lang['LAYOUT_SETTINGS'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-paint icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          {!props.subscribedPackage && <AlertNotSubscribe {...props} />}
          <Card>
            <CardHeader>
              {Lang['LAYOUT_SETTINGS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </CardHeader>
            <CardBody>
              <Row>
                <Col lg={6}>
                  <FormGroup>
                    <Label>
                      {Lang['BACKGROUND_IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <>
                      <Input
                        type="text"
                        value={formData.background_image}
                        disabled={true} />
                      <span className='d-block font-italic'>{ Lang[ 'SUGGESTED_IMAGE_SIZE' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</span>
                      <Button
                        color="primary"
                        className={'mt-2'}
                        onClick={() => {
                          props.toggleMediaDatabase(true)
                          updateSelectedImage('background_image')
                        }}>{Lang['SELECT_IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}</Button>
                    </>
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label>
                      {Lang['CHAT_LOGO'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <>
                      <Input
                        type="text"
                        value={formData.chat_logo}
                        disabled={true} />
                      <span className='d-block font-italic'>{ Lang[ 'SUGGESTED_LOGO_IMAGE_SIZE' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</span>
                      <Button
                        color="primary"
                        className={'mt-2'}
                        onClick={() => {
                          updateSelectedImage('chat_logo')
                          props.toggleMediaDatabase(true)
                        }}>{Lang['SELECT_IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}</Button>
                    </>
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <hr />
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      {Lang['HEADER_FOOTER_BACKGROUND_COLOR'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <SketchPicker
                      color={formData.header_background_color}
                      onChange={col => setFormData({
                        ...formData,
                        header_background_color: col.hex
                      })} />
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      {Lang['CUSTOMER_MESSAGE_BACKGROUND_COLOR'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <SketchPicker
                      color={formData.customer_message_background_color}
                      onChange={col => setFormData({
                        ...formData,
                        customer_message_background_color: col.hex
                      })} />
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      {Lang['SUPPORT_MESSAGE_BACKGROUND_COLOR'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <SketchPicker
                      color={formData.support_message_background_color}
                      onChange={col => setFormData({
                        ...formData,
                        support_message_background_color: col.hex
                      })} />
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      {Lang['BACKGROUND_TEXT_FONT_COLOR'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <SketchPicker
                      color={formData.background_text_font_color}
                      onChange={col => setFormData({
                        ...formData,
                        background_text_font_color: col.hex
                      })} />
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      {Lang['MESSAGE_TEXT_FONT_COLOR'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <SketchPicker
                      color={formData.message_text_font_color}
                      onChange={col => setFormData({
                        ...formData,
                        message_text_font_color: col.hex
                      })} />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex">
                <Button
                  className="ml-auto"
                  onClick={() => onHandleSubmit()}
                >
                  {Lang['SUBMIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </ReactCSSTransitionGroup>
      {
        props.onLoadSettingHOC && <LoadingOverlay />
      }
      <MediaDatabase
        allowed={['jpg', 'jpeg', 'png']}
        selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
        onSelectedImage={(param) => {
          if (param) {
            setFormData({
              ...formData,
              [selectedImage]: param
            })
          }
          updateSelectedImage('')
          props.toggleMediaDatabase(false)
        }} />
    </>
  );
}

export default WithHOC(Setting)